<template>
  <label class="item-center flex space-x-3">
    <FreeRadio
      type="checkbox"
      name="agreement-checkbox"
      :checked="checked"
      @change="emit('onChange', !checked)"
    />
    <p class="text-text-neutral-quaternary text-sm">
      <slot />
    </p>
  </label>
</template>

<script setup lang="ts">
  import { FreeRadio } from 'freedom-shared';

  defineProps<{
    checked?: boolean;
  }>();

  const emit = defineEmits<{
    onChange: [boolean];
  }>();
</script>
